import { PAGES } from '@/constants/pages';

export const NAVIGATION_KEYS = {
  '/H': PAGES.HOME,
  '/C': PAGES.COMPANIES,
  '/I': PAGES.INVESTORS,
  '/A': PAGES.ADMIN,
} as const;

export type NavigationKey = keyof typeof NAVIGATION_KEYS;
